import PropTypes from "prop-types"
import React from "react"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { mb, mt, py } from "styled-components-spacing"

import { ButtonAnchor } from "./atoms/Buttons"
import { H4 } from "./atoms/Headings"
import { Link } from "./atoms/Link"
import SocialButton from "./atoms/SocialButton"
import { useAllTemplateTypes } from "./hooks/useAllTemplateTypes"
import { SIDEBAR_BREAKPOINT } from "./SideBar"
import { HR } from "./Typography"

const LinkResolver = require("../utils/linkResolver")

const FooterEl = styled.footer`
  /* ${mt(3)}; */
  ${py(3)};
  display: flex;
  flex-direction: column;
  bottom: 0;
  width: 100%;
  line-height: 23px;
  color: ${props => props.theme.colors.darkGrey};
  text-align: center;
  border-top: ${props =>
    !props.hideDiscoverButton &&
    `1px solid ${props => props.theme.colors.lightGrey}`};

  ${breakpoint("md")(
    () => css`
      text-align: left;
      /* flex-direction: row; */
    `
  )}

  ${breakpoint(SIDEBAR_BREAKPOINT)(css`
    position: absolute;
  `)}
`
const MobileExtras = styled("div")`
  text-align: center;
  order: -2;

  ${breakpoint(`md`)(
    css`
      display: none;
    `
  )}
`
const SocialContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  order: -1;
  flex: 0;
  ${mb(1)}

  ${breakpoint(`md`)(
    () => css`
      margin-top: 0;
      order: initial;
    `
  )}

  ${SocialButton} {
    margin: 0 4px 8px;
    display: block;
  }
`

export const Footer = ({ hideDiscoverButton }) => {
  const templateTypes = useAllTemplateTypes()
  const Year = () => {
    const d = new Date()
    return d.getFullYear()
  }
  return (
    <>
      <FooterEl hideDiscoverButton={hideDiscoverButton}>
        {/* {!hideDiscoverButton && ( */}
        <MobileExtras>
          {/* TODO: this is temporary until the category cards are added back in */}
          {!hideDiscoverButton && (
            <>
              <ButtonAnchor size={2} upperCase href={"https://karbonhq.com"}>
                Discover Karbon
              </ButtonAnchor>
              <HR mt={3} mb={3} />
            </>
          )}
          <H4>Categories</H4>
          <ul
            css={css`
              list-style: none;
              padding: 0;
            `}
          >
            {templateTypes.map(type => (
              <li key={type}>
                <Link to={LinkResolver("TemplateList", type)}>{type}</Link>
              </li>
            ))}
          </ul>
        </MobileExtras>
        {/* )} */}
        <HR mt={3} mb={3} />
        <div
          css={css`
            display: flex;
            flex-direction: column;

            ${breakpoint("md")(
              css`
                flex-direction: row;
              `
            )}
          `}
        >
          <div
            css={css`
              flex: 1;
            `}
          >
            Copyright © <Year /> Karbon Inc.
          </div>
          <SocialContainer>
            <SocialButton
              small
              rel="me nofollow noreferrer"
              href="https://www.linkedin.com/company/karbonhq/"
              target="_blank"
              icon="linkedIn"
              title="Karbon on LinkedIn"
            >
              Karbon on LinkedIn
            </SocialButton>
            <SocialButton
              small
              rel="me nofollow noreferrer"
              href="https://facebook.com/karbonhq"
              target="_blank"
              icon="facebook"
              title="Karbon on facebook"
            >
              Karbon on facebook
            </SocialButton>
            <SocialButton
              small
              rel="me nofollow noreferrer"
              href="https://www.instagram.com/karbonhq"
              target="_blank"
              icon="instagram"
              title="@karbonhq on Instagram"
            >
              @karbonhq on YouTube
            </SocialButton>
            <SocialButton
              small
              rel="me nofollow noreferrer"
              href="https://www.youtube.com/karbonhq"
              target="_blank"
              icon="youtube"
              title="Karbon on YouTube"
            >
              @karbonhq on YouTube
            </SocialButton>
          </SocialContainer>
        </div>
      </FooterEl>
    </>
  )
}

Footer.propTypes = {
  hideDiscoverButton: PropTypes.bool,
}
